/// <amd-module name="Wit/Common/WITMeMacroPeoplePickerProvider" />

import { PeoplePickerProvider } from "VSS/Features/Identities/IdentityPickerProvider";
import { IdentitiesSearchRequestModel } from "VSS/Features/Identities/IdentityService";
import { IVssPageContext } from "VSS/Platform/Context";
import { getAssetLocation } from "VSS/Platform/Location";
import { IIdentity } from "VSSUI/IdentityPicker";
import { getLocalizedOperator, WiqlOperators } from "Wit/Common/WiqlOperators";

// Implement the PeoplePickerProvider to add the @Me macro
export class WITMeMacroPeoplePickerProvider extends PeoplePickerProvider {
    private _meMacro: IIdentity;

    constructor(pageContext: IVssPageContext, defaultRequestProps?: Partial<IdentitiesSearchRequestModel>) {
        super(pageContext, defaultRequestProps);
        this._meMacro = {
            displayName: getLocalizedOperator(WiqlOperators.MacroMe),
            entityId: WiqlOperators.MacroMe,
            entityType: "User",
            originDirectory: "",
            originId: "",
            image: getAssetLocation(pageContext, "ms.vss-work-web/common-content/Content/memacro-user.svg")
        };
    }

    public onEmptyInputFocus(): IIdentity[] | PromiseLike<IIdentity[]> {
        const identities = super.onEmptyInputFocus();
        if (Array.isArray(identities)) {
            identities.unshift(this._meMacro);
            return identities;
        } else {
            return identities.then(identities => {
                identities.unshift(this._meMacro);
                return identities;
            });
        }
    }

    public onFilterIdentities(filter: string, selectedItems?: IIdentity[]): Promise<IIdentity[]> | IIdentity[] {
        const personaResults = super.onFilterIdentities(filter, selectedItems);

        if (!this.filterMatchesMeMacro(filter)) {
            return personaResults;
        }

        if (personaResults instanceof Promise) {
            return personaResults.then(identities => {
                identities.unshift(this._meMacro);
                return identities;
            });
        }

        personaResults.unshift(this._meMacro);
        return personaResults;
    }

    private filterMatchesMeMacro(filter: string): boolean {
        const normalizedFilter = filter.toLocaleLowerCase();
        return WiqlOperators.MacroMe.toLocaleLowerCase().includes(normalizedFilter) || this._meMacro.displayName!.includes(normalizedFilter);
    }
}
